import { render, staticRenderFns } from "./OrganizationHeader.vue?vue&type=template&id=a62980d4&scoped=true"
import script from "./OrganizationHeader.vue?vue&type=script&lang=js"
export * from "./OrganizationHeader.vue?vue&type=script&lang=js"
import style0 from "./OrganizationHeader.vue?vue&type=style&index=0&id=a62980d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62980d4",
  null
  
)

export default component.exports